/* ogai-phone-buy.js: added 2026-11-01.

   On a phone the Add to cart button is about three screens down the Core page.
   This shows the theme's sticky buy bar whenever that button is out of view,
   rather than only after scrolling past the whole product section.

   The bar's button clicks the main button rather than submitting its own form,
   so the drive and package chosen on the page are always the ones added. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var main = document.querySelector('button[id^="ProductSubmitButton-"]');
    var bar = document.querySelector('.product-sticky-cart');
    if (!main || !bar) return;

    var mainInView = true;

    function update() {
      bar.classList.toggle('ogai-buy-visible', !mainInView && window.scrollY > 300);
    }

    new IntersectionObserver(function (entries) {
      mainInView = entries[entries.length - 1].isIntersecting;
      update();
    }).observe(main);

    window.addEventListener('scroll', update, { passive: true });

    bar.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('button[type="submit"], button[name="add"]');
        if (!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (main.disabled) {
          main.scrollIntoView({ block: 'center' });
        } else {
          main.click();
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
